var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.order
    ? _c("div", [
        _vm.order.SaleAreaId == _vm.SALE_AREAS.RESTAURANT
          ? _c("div", [
              _c(
                "div",
                { staticClass: "flex-center-center border-bottom-bo-grey3" },
                [
                  _c("i", { staticClass: "fie-icon_delivery p-20 fsize-25" }),
                  _vm._v(" "),
                  _c("div", [_vm._v("Table " + _vm._s(_vm.order.Table))]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.SaleAreaId == _vm.SALE_AREAS.DELIVERY
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "flex-center-center border-bottom-bo-grey3",
                  on: {
                    click: function ($event) {
                      return _vm.edit(_vm.CHECKOUT.DELIVERY_DATE)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fie-icon_delivery p-20 fsize-25" }),
                  _vm._v(" "),
                  _c("div", [_vm._v("Livraison " + _vm._s(_vm.readyTime))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default ml-auto border-0",
                      staticStyle: { color: "var(--color2)" },
                    },
                    [_vm._v("\n                Modifier\n            ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex-center-center border-bottom-bo-grey3",
                  on: {
                    click: function ($event) {
                      return _vm.edit(_vm.CHECKOUT.DELIVERY_ADDRESS)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-home fa-2x p-20" }),
                  _vm._v(" "),
                  _vm.address
                    ? _c("div", { staticClass: "flex-column" }, [
                        _c("div", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.address.PlusCode) +
                              " " +
                              _vm._s(_vm.address.Address) +
                              ",\n                    " +
                              _vm._s(_vm.address.Zip) +
                              " " +
                              _vm._s(_vm.address.City) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    : _c("div", [_vm._v("--")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default ml-auto border-0",
                      staticStyle: { color: "var(--color2)" },
                    },
                    [_vm._v("\n                Modifier\n            ")]
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.SaleAreaId == _vm.SALE_AREAS.TO_GO ||
        _vm.order.SaleAreaId == _vm.SALE_AREAS.TO_STAY
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "flex-center-center border-bottom-bo-grey3",
                  on: {
                    click: function ($event) {
                      return _vm.edit(_vm.CHECKOUT.DELIVERY_DATE)
                    },
                  },
                },
                [
                  _vm.order.SaleAreaId == _vm.SALE_AREAS.TO_STAY
                    ? _c("i", { staticClass: "fie-icon_store p-20 fsize-25" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.order.SaleAreaId == _vm.SALE_AREAS.TO_GO
                    ? _c("i", {
                        staticClass: "fie-icon_takeaway2 p-20 fsize-25",
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [_vm._v("A récupérer " + _vm._s(_vm.readyTime))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "btn btn-default ml-auto mr-10 border-0" },
                    [_vm._v("\n                Modifier\n            ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex-center-center border-bottom-bo-grey3",
                  on: {
                    click: function ($event) {
                      return _vm.edit(_vm.CHECKOUT.CHOOSE_SHOP)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-map-marker fa-2x p-20" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-column" }, [
                    _c("div", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.order.shop.DefaultName) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.order.shop.Address1) +
                          " " +
                          _vm._s(_vm.order.shop.Address2) +
                          ",\n                    " +
                          _vm._s(_vm.order.shop.City) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "btn btn-default ml-auto mr-10 border-0" },
                    [_vm._v("\n                Modifier\n            ")]
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }